import React, { Component } from 'react';

export type SimpleTableProps = {
    headers: string[];
    rows: (JSX.Element | string | number)[][];
    className?: string;
};

export default class SimpleTable extends Component<SimpleTableProps> {
    static displayName = SimpleTable.name;

    render() {
        const passedClass = this.props.className ? ` ${this.props.className}` : "";
        return (
            <table className={`simple-table${passedClass}`}>
                <thead>
                    <tr>
                        {this.props.headers.map((header, index) => (
                            <th key={index}>
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {this.props.rows.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {row.map((col, colIndex) => (
                                <td key={colIndex}>
                                    {col}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }
}
